import PropTypes from 'prop-types';
import React from 'react';
import { Container, Row } from 'react-bootstrap';
import ListOfDescriptionsAndCards from '../ListOfDescriptions/ListOfDescriptionsAndCards';
import SectionHeader from '../SectionHeader/SectionHeader';
import { headerWithImageType } from 'src/types';

function IconsSectionAndCards({ cards, sections, sectionHeader: { title, tagline, image } }) {
  return (
    <Container as="section" fluid className="py-5">
      <SectionHeader title={title} tagline={tagline} image={image} />

      <Container className="mt-4">
        <Row>
          <ListOfDescriptionsAndCards cards={cards} descriptions={sections} />
        </Row>
      </Container>
    </Container>
  );
}

IconsSectionAndCards.propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.node.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      _key: PropTypes.string.isRequired,
    })
  ).isRequired,
  sections: PropTypes.arrayOf(
    PropTypes.shape({
      _key: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
      image: PropTypes.shape({}).isRequired,
    })
  ).isRequired,
  sectionHeader: headerWithImageType.propTypes,
};

IconsSectionAndCards.defaultProps = {
  sectionHeader: headerWithImageType.defaultProps,
};

export default IconsSectionAndCards;
